import type { ClientOptions } from 'ws';
import type { BaseVendorApiClientSettings } from './base';
import type { VendorApiHttpAgentSettings } from './http';

export interface WebsocketTimeouts {
  wsAwaitedMessageTimeoutSec?: number;
  wsConnectTimeoutSec?: number;
  wsPingIntervalSec?: number;
  wsSendMessageTimeoutSec?: number;
  wsIdleMaxSec?: number;
}

export interface WebsocketParsingOptions {
  wsParseIncomingData?: boolean;
}

export interface WebsocketClientSettings
  extends BaseVendorApiClientSettings,
    VendorApiHttpAgentSettings,
    Omit<ClientOptions, 'protocol' | 'host'>,
    WebsocketParsingOptions,
    WebsocketTimeouts {
  url: `ws://${string}` | `wss://${string}`;
}
